
import React from "react";
import { AlertCircle, Check, X } from "lucide-react";
import "../../Styles/Toast.css"; 

const Toast = ({ type, message, onClose }) => {
  if (!message) return null;
  
  return (
    <div className={`toast-notification ${type}`}>
      {type === 'error' ? <AlertCircle size={20} /> : <Check size={20} />}
      <span>{message}</span>
      <button onClick={onClose} className="toast-close-btn">
        <X size={16} />
      </button>
    </div>
  );
};

export default Toast;
